export default __webpack_public_path__ + "img/tiny-22.0e56abbf.jpg";